import { Nullable } from "../..";
import { PropertyCopyMethod } from "./property-copy-method";

/**
 * Defines a property copy option.
 */
export interface IPropertyCopyOption {
    /**
     * Gets or sets the name of the property.
     */
    name: string;

    /**
     * Gets or sets the copy method.
     */
    method: PropertyCopyMethod;

    /**
     * Gets or sets the new value for the property.
     */
    newValue: Nullable<string>;
}

export class PropertyCopyOption implements IPropertyCopyOption {
    /**
     * {@inheritDoc}
     */
    name: string;

    /**
     * {@inheritDoc}
     */
    method: PropertyCopyMethod;

    /**
     * {@inheritDoc}
     */
    newValue: Nullable<string>;

    constructor(name: string, method: PropertyCopyMethod, newValue: Nullable<string> = null) {
        this.name = name;
        this.method = method;
        this.newValue = newValue ?? null;
    }
}
